import React, { useState, useEffect } from 'react';
import {
  getImageReference,
  getItemReference,
} from '@tiicker/util/lib/contentful/helpers';
import { ContentSection } from '@tiicker/util/lib/contentful/types';
import SwiperCarousel from 'components/Carousel/SwiperCarousel';
import Markdown from 'components/Markdown/Markdown';
import { Entry } from 'contentful';
import styles from './PartnerWithUsTestimonialSection.module.scss';

interface Props {
  contentSections: Entry<ContentSection>[];
  includes: any;
}

interface TestimonialProps {
  section: Entry<ContentSection>;
  includes: any;
}

const PartnerWithUsTestimonial = (props: TestimonialProps) => {
  const brandLogo = getImageReference(props.section.fields.image, props.includes);
  const ceoImage = getImageReference(props.section.fields.download, props.includes);

  return (
    <div className={styles.PartnerWithUsTestimonialSection__testimonial}>
      <div
        className={
          styles.PartnerWithUsTestimonialSection__testimonial__brandLogo
        }
      >
        {brandLogo && (
          <img
            src={brandLogo.fields.file.url}
            alt={brandLogo.fields.description}
          />
        )}
      </div>
      <Markdown
        markdownText={props.section.fields.textContent}
        className={styles.PartnerWithUsTestimonialSection__testimonial__text}
      />
      <div className={styles.PartnerWithUsTestimonialSection__testimonial__owner}>
        <div className={styles.PartnerWithUsTestimonialSection__testimonial__owner__ceoLogo}>
          {ceoImage && (
            <img
              src={ceoImage.fields.file.url}
              alt={ceoImage.fields.description}
            />
          )}
        </div>
        <div className={styles.PartnerWithUsTestimonialSection__testimonial__owner__textarea}>
          {props.section.fields.secondaryTextContent && (
            <Markdown
              markdownText={props.section.fields.secondaryTextContent}
              className={
                styles.PartnerWithUsTestimonialSection__testimonial__owner__author
              }
            />
          )}
          <div
            className={styles.PartnerWithUsTestimonialSection__testimonial__owner__role}
          >
            {props.section.fields.tertiaryTextContent}
          </div>
        </div>
      </div>
    </div>
  );
};

const PartnerWithUsTestimonialSection = (props: Props) => {
  const [windowWidth, setWindowWidth] = useState<number>(0);
  const mediumBreakpoint = 992; // Make sure this value matches your SCSS file

  useEffect(() => {
    // Update the window width after the component has been mounted
    setWindowWidth(window.innerWidth);

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={styles.PartnerWithUsTestimonialSection}>
      {windowWidth > mediumBreakpoint ? (
        <div className={styles.PartnerWithUsTestimonialSection__testimonialsGrid}>
          {props.contentSections.map((section) => (
            <PartnerWithUsTestimonial
              key={`testimonial-${section.sys.id}`}
              section={section}
              includes={props.includes}
            />
          ))}
        </div>
      ) : (
        <SwiperCarousel
          slides={props.contentSections.map((section) => {
            return (
              <PartnerWithUsTestimonial
                key={`testimonial-${section.sys.id}`}
                section={section}
                includes={props.includes}
              />
            );
          })}
          spaceBetween={16}
          slidesPerView={1.05}
          slidesPerGroup={1}
          centeredSlides
          pagination
          navigationLayout={'partner'}
        />
      )}
    </div>
  );
};

export default PartnerWithUsTestimonialSection;
